import React from 'react';
import { Section } from './Section';
import { Calendar, Dumbbell, ClipboardList, Gamepad2, Users, HeartPulse, Check } from 'lucide-react';
const tomos = [{
  num: 1,
  title: 'De Cero a la Cancha: Planificación Anual del Entrenador',
  subtitle: 'Organización esencial',
  desc: 'Cómo armar tu temporada completa: macrociclos, microciclos y plantillas listas para usar desde el primer día',
  icon: Calendar,
  color: 'text-emerald-400',
  bg: 'bg-emerald-500/10',
  border: 'border-emerald-500/30'
}, {
  num: 2,
  title: 'Fichero Técnico: 80 Ejercicios Listos para Entrenar',
  subtitle: '80 ejercicios listos',
  desc: 'Fundamentos técnicos completos con diagramas, objetivos y progresión por nivel: saque, recepción, colocación, remate y bloqueo',
  icon: Dumbbell,
  color: 'text-emerald-400',
  bg: 'bg-emerald-500/10',
  border: 'border-emerald-500/30'
}, {
  num: 3,
  title: 'Evalúa y Mejora: Sistema de Seguimiento de Jugadoras',
  subtitle: 'Planillas incluidas',
  desc: 'Llevá el registro real del progreso de tus jugadoras y mostrá resultados concretos a padres y dirigentes',
  icon: ClipboardList,
  color: 'text-yellow-400',
  bg: 'bg-yellow-500/10',
  border: 'border-yellow-500/30'
}, {
  num: 4,
  title: 'Entrenamientos que Enganchan: Juegos, Dinámicas y Actividades',
  subtitle: '40 dinámicas listas',
  desc: 'Diseñá entrenamientos que motiven, diviertan y retengan a tus jugadoras semana tras semana',
  icon: Gamepad2,
  color: 'text-red-400',
  bg: 'bg-red-500/10',
  border: 'border-red-500/30'
}, {
  num: 5,
  title: 'Profe Sin Drama: Gestión del Grupo, Padres y Club',
  subtitle: 'Plantillas incluidas',
  desc: 'Manejá conflictos, comunicación con padres e institución como un profesional del deporte',
  icon: Users,
  color: 'text-blue-400',
  bg: 'bg-blue-500/10',
  border: 'border-blue-500/30'
}, {
  num: 6,
  title: 'Cuerpo en Juego: Preparación Física y Prevención de Lesiones',
  subtitle: 'Protocolos incluidos',
  desc: 'Trabajá la parte física con seguridad aunque no seas preparador físico: rutinas, prevención y protocolo ante lesiones',
  icon: HeartPulse,
  color: 'text-purple-400',
  bg: 'bg-purple-500/10',
  border: 'border-purple-500/30'
}];
const includes = ['Planificación lista para usar desde el primer entrenamiento', 'Ejercicios con objetivo, desarrollo y variantes por nivel', 'Indicaciones técnicas listas para usar en cancha', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por fundamento', 'Checklist pre y durante el entrenamiento', 'Planillas de seguimiento de jugadoras', 'Adaptaciones para grupos heterogéneos', '100% adaptado a la realidad del profe de volley argentino'];
export function Tomos() {
  return <Section data-id="element-342">
      <div className="text-center mb-8 md:mb-16" data-id="element-343">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-344">
          Los 6 Tomos
        </h2>
        <p className="text-lg md:text-xl text-gray-400" data-id="element-345">
          Para profes de volley de todos los niveles y enfoques
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-20" data-id="element-346">
        {tomos.map(tomo => <div key={tomo.num} className={`bg-navy-900 rounded-xl md:rounded-2xl p-4 md:p-8 border border-navy-700 hover:border-gold-500/50 transition-all duration-300 group flex flex-row md:flex-col items-start gap-3 md:gap-0 border-l-4 md:border-l border-l-${tomo.color.split('-')[1]}-500/50 md:border-l-navy-700`} data-id="element-347">
            <div className={`w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl ${tomo.bg} ${tomo.border} border flex items-center justify-center md:mb-6 group-hover:scale-110 transition-transform shrink-0`} data-id="element-348">
              <tomo.icon className={`w-5 h-5 md:w-7 md:h-7 ${tomo.color}`} data-id="element-349" />
            </div>
            <div data-id="element-350">
              <div className="text-[10px] md:text-sm font-bold text-gray-500 mb-1 md:mb-2 uppercase tracking-wider" data-id="element-351">
                Tomo {tomo.num}
              </div>
              <h3 className="text-base md:text-xl font-heading font-bold text-white mb-2 md:mb-3 leading-tight" data-id="element-352">
                {tomo.title}
              </h3>
              <div className={`inline-block px-2 py-0.5 md:px-3 md:py-1 rounded-full text-[10px] md:text-xs font-semibold mb-0 md:mb-4 ${tomo.bg} ${tomo.color}`} data-id="element-353">
                {tomo.subtitle}
              </div>
              <p className="text-gray-400 text-sm leading-relaxed hidden md:block mt-2 md:mt-0" data-id="element-354">
                {tomo.desc}
              </p>
            </div>
          </div>)}
      </div>

      <div className="bg-navy-900 rounded-xl md:rounded-3xl p-5 md:p-12 border border-gold-500/20 max-w-4xl mx-auto" data-id="element-355">
        <h3 className="text-xl md:text-3xl font-heading font-bold text-center text-white mb-5 md:mb-10" data-id="element-356">
          Cada tomo incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 md:gap-y-4" data-id="element-357">
          {includes.map((item, idx) => <div key={idx} className="flex items-start gap-2 md:gap-3" data-id="element-358">
              <div className="bg-gold-500/20 rounded-full p-1 mt-0.5" data-id="element-359">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-gold-500" data-id="element-360" />
              </div>
              <p className="text-gray-300 text-sm md:text-base" data-id="element-361">{item}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}